import i18n from '../i18n';
import config from '../helpers/configProvider';

export default {
  headerList: [
    {
      name: 'API key',
      type: 'text',
      path: 'apiKey',
      disabledInEditMode: true,
      visibleInCreateMode: false
    },
    {
      name: 'Username',
      type: 'text',
      path: 'username',
      rules: [
        (v) => !!v || i18n.t('This field is required!'),
        (v) => (v && v.length <= 10) || i18n.t('Username cannot be longer than 10 characters!')
      ],
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'Access level',
      type: 'select',
      path: 'role',
      rules: [(v) => !!v || i18n.t('This field is required!')],
      items: ['user', 'editor', 'admin'],
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'Password',
      type: 'password',
      path: 'password',
      rules: [
        (v) => (v && v.length > 5) || i18n.t('The password must be at least 6 characters long!'),
        (v) => !!v || i18n.t('This field is required!')
      ],
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'First name',
      type: 'text',
      path: 'firstName',
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'Last name',
      type: 'text',
      path: 'lastName',
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'Email',
      type: 'email',
      path: 'email',
      rules: [
        (v) =>
          /^$/.test(v) ||
          /[^@]+@[^@]+\.[^@]+/.test(v) ||
          i18n.t('The email address format is not correct!')
      ],
      disabledInEditMode: false,
      visibleInCreateMode: true
    },
    {
      name: 'Table name',
      type: 'list',
      paths: [
        {
          label: 'View',
          field: 'tableView'
        },
        {
          label: 'Edit',
          field: 'tableEdit'
        }
      ],
      disabledInEditMode: false,
      visibleInCreateMode: Boolean(config.getEnv(config.enum.VUE_APP_AUTH_SERVICE_ENABLED))
    }
  ]
};
